module.exports = ".input {\n    padding: 10px 10px;\n}\n\nmat-form-field {\n    width: 80%;\n}\n\nmat-dialog-actions {\n    justify-content: flex-end;\n}\n"